import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { PaginatorState } from 'primeng/paginator';
import { catchError, debounceTime, of } from 'rxjs';
import { AssetManagementControllerGetAll$Params } from 'src/app/api/fn/asset-management/asset-management-controller-get-all';
import { AssetManagementItem, AssetManagementListResponse, BaseResponse } from 'src/app/api/models';
import { AssetManagementService, IdentityService } from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-modal-search-by-serial',
  templateUrl: './modal-search-by-serial.component.html',
  styleUrls: ['./modal-search-by-serial.component.scss'],
})
export class ModalSearchBySerialComponent {
  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  totalRecords: number = 0;
  related_agreement_id: number;
  loading = false;
  frm_search = new FormGroup({
    serial_numbers: new FormControl<string | undefined>(''),
    skip: new FormControl<number>(0),
    pageSize: new FormControl<number>(this.rowsPerPageOptions[0]),
  });
  assets: AssetManagementItem[] = [];
  selectedAssets: AssetManagementItem[] = [];

  constructor(
    public auth: AuthService,
    private assetMgmtService: AssetManagementService,
    private userService: IdentityService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.related_agreement_id = config.data?.related_agreeement_id;
  }

  ngOnInit() {
    const preselectedAssets = this.config.data!.selectedAssets || [];
    if (preselectedAssets.length > 0) {
      this.assetMgmtService
        .assetManagementControllerGetAll({
          limit: preselectedAssets.length,
          skip: 0,
          serial_numbers: preselectedAssets,
        })
        .pipe(
          catchError(() =>
            of({
              result: false,
              message: '',
              data: {
                list: [],
                count: 0,
              },
            } as BaseResponse & {
              'data'?: AssetManagementListResponse;
            })
          )
        )
        .subscribe({
          next: res => {
            this.selectedAssets.push(...res.data.list);
            this.assets = [...this.selectedAssets];
          },
          error: err => {
            //Ignore error
          },
        });
    }
    this.frm_search
      .get('serial_numbers')
      ?.valueChanges.pipe(debounceTime(500))
      .subscribe(v => {
        if (v) {
          this.frm_search.get('skip')?.setValue(0);
          this.frm_search.get('pageSize')?.setValue(this.rowsPerPageOptions[0]);
        } else {
          const serialNumbers =
            v
              ?.split(',')
              .filter(x => !!x)
              .map(x => x.trim()) || [];
          this.frm_search.get('skip')?.setValue(0);
          this.frm_search.get('pageSize')?.setValue(serialNumbers.length);
        }
        this.fetch();
      });
    this.fetch();
  }

  fetch() {
    this.loading = true;
    const serialNumbers =
      this.frm_search.value.serial_numbers
        ?.split(',')
        .filter(x => !!x)
        .map(x => x.trim()) || [];

    const params: AssetManagementControllerGetAll$Params = {
      limit: this.frm_search.get('pageSize')?.value!,
      skip: this.frm_search.get('skip')?.value!,
      related_agreement_id: this.related_agreement_id!,
      serial_numbers: serialNumbers.length > 0 ? serialNumbers : undefined,
    };
    // if (event.globalFilter != null) {
    //   if (event.globalFilter[0] != '') {
    //     params.serial_number = event.globalFilter[0];
    //   }
    // }
    this.assetMgmtService.assetManagementControllerGetAll(params).subscribe({
      next: res => {
        this.assets = res.data.list;
        this.totalRecords = res.data.count;
        this.loading = false;
      },
    });
  }

  onPageChange(event: PaginatorState) {
    this.frm_search.get('skip')?.setValue(event.first || 0);
    this.frm_search.get('pageSize')?.setValue(event.rows || this.rowsPerPageOptions[0]);
    this.fetch();
  }

  onSubmit() {
    this.ref.close({
      found: this.selectedAssets,
    });
  }
}
